import React from 'react';
import { appConfig } from 'config/appConfig';
import { FiLifeBuoy } from 'react-icons/fi';
import { Button } from 'components';
import * as routes from 'constants/routes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
const PageNotFound = () => {
  const loggedUserInfo = useSelector(state => state.login);

  const redirectRoute = loggedUserInfo.isSuperAdmin ? routes.ADMIN_HOME : routes.HOME;
  return (
    <div className="pageNotFound">
      <img src={appConfig.logo} alt="logo" width="160" className="mb-10x" />
      <FiLifeBuoy className="lf-color-tertiary-red-60 mb-5x" size={64} />
      <h3 className="pageNotFound__title mb-5x">Page not found</h3>
      <p className="pageNotFound__subtitle mb-8x">Unfortunately, the page you were looking for was not found.</p>
      <Link to={redirectRoute} href="#">
        <Button secondary>Go back home</Button>
      </Link>
    </div>
  );
};

export default PageNotFound;
